/**
 * You do not have to modify this file,
 * unless you absolutely know what you are doing.
 */
import Vue, { PluginObject, VueConstructor } from "vue";
import initClients from "@/repository";

type IRepos = ReturnType<typeof initClients>;

declare module "vue/types/vue" {
  interface Vue {
    $repo: IRepos;
  }
  interface VueConstructor {
    $repo: IRepos;
  }
}

// Initialize all clients
const _repos = initClients();

// Bind client object to Vue instances
const RepoPlugin: PluginObject<Vue> = {
  install: (Vue) => {
    Vue.$repo = _repos;
    Object.defineProperties(Vue.prototype, {
      $repo: {
        get() {
          return _repos;
        },
      },
    });
  },
};

Vue.use(RepoPlugin);

export default RepoPlugin;
